import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import  "../Invs/AFReadyDisigen/invoiceprint.css"
const createInvoicePDF2 = async () => {

    const pages = Array.from(
        document.querySelectorAll(".pageinv")
    );

    if (!pages.length) {
        throw new Error("لم يتم العثور على صفحات الفاتورة");
    }

    // انتظار الخطوط
    if (document.fonts) {
        await document.fonts.ready;
    }

    let pdf = null;

    for (let i = 0; i < pages.length; i++) {

        const element = pages[i];

        const rect = element.getBoundingClientRect();

        if (!rect.width || !rect.height) {
            continue;
        }

        // تحويل الصفحة
        const canvas = await html2canvas(element, {
            scale: 1.5,                 // مهم للسرعة والحجم
            backgroundColor: "#fff",
            useCORS: true,
            // allowTaint: false,
            logging: false,
            // imageTimeout: 3000,
            width: Math.ceil(rect.width),
            height: Math.ceil(rect.height)
        });

        // CSS pixels → mm
        const widthMM =
            rect.width * 25.4 / 96;

        const heightMM =
            rect.height * 25.4 / 96;

        if (!pdf) {

            pdf = new jsPDF({
                orientation:
                    "portrait",
                unit: "mm",
                format: [
                    widthMM,
                    heightMM
                ],

                compress: true
            });

        } else {

            pdf.addPage(
                [widthMM, heightMM],
                widthMM > heightMM
                    ? "landscape"
                    : "portrait"
            );
        }

        // JPEG أصغر بكثير من PNG
        const imageData = canvas.toDataURL(
            "image/jpeg",
            0.90
        );

        pdf.addImage(
            imageData,
            "JPEG",
            0,
            0,
            widthMM,
            heightMM,
            undefined,
            "FAST"
        );

        // تحرير الذاكرة
        canvas.width = 1;
        canvas.height = 1;
    }

    if (!pdf) {
        throw new Error("فشل إنشاء PDF");
    }

    return pdf;
};

const createInvoicePDF1 = async () => {
    const pages = Array.from(
        document.querySelectorAll(".pageinv")
    );

    if (!pages.length) {
        throw new Error("لم يتم العثور على صفحات الفاتورة");
    }

    // =====================================================
    // 1) التأكد من تحميل جميع الخطوط المستخدمة في الصفحة
    // =====================================================

    if (document.fonts) {
        await document.fonts.ready;

        // انتظار إضافي حتى يعيد المتصفح رسم النصوص
        await new Promise(resolve => requestAnimationFrame(resolve));
        await new Promise(resolve => requestAnimationFrame(resolve));
    }

    // =====================================================
    // 2) إنشاء PDF
    // سيتم تحديد مقاس كل صفحة حسب تصميم React
    // =====================================================

    let pdf = null;

    for (let i = 0; i < pages.length; i++) {

        const element = pages[i];

        // ================================================
        // التأكد أن العنصر ظاهر ومكتمل
        // ================================================

        const rect = element.getBoundingClientRect();

        if (!rect.width || !rect.height) {
            continue;
        }

        // ================================================
        // إجبار المتصفح على إعادة الرسم
        // ================================================

        element.getBoundingClientRect();

        await new Promise(resolve =>
            requestAnimationFrame(resolve)
        );

        // ================================================
        // تحويل صفحة React إلى Canvas عالي الجودة
        // ================================================

        const canvas = await html2canvas(element, {

            // 4 أفضل من 3 إذا الجهاز يتحمل
            scale: 3,

            useCORS: true,

            allowTaint: false,

            backgroundColor: "#ffffff",

            logging: false,

            imageTimeout: 0,

            removeContainer: true,

            foreignObjectRendering: false,

            // الحفاظ على أبعاد الصفحة
            width: Math.ceil(rect.width),

            height: Math.ceil(rect.height),

            windowWidth: Math.max(
                document.documentElement.clientWidth,
                Math.ceil(rect.right)
            ),

            windowHeight: Math.max(
                document.documentElement.clientHeight,
                Math.ceil(rect.bottom)
            )
        });

        // ================================================
        // تحويل البكسل إلى mm
        //
        // 96 DPI = CSS pixel
        // ================================================

        const widthMM =
            (canvas.width / 4) * 25.4 / 96;

        const heightMM =
            (canvas.height / 4) * 25.4 / 96;

        // ================================================
        // أول صفحة: إنشاء PDF بمقاس الصفحة الحقيقي
        // ================================================

        if (!pdf) {

            pdf = new jsPDF({
                orientation:
                    widthMM > heightMM
                        ? "landscape"
                        : "portrait",

                unit: "mm",

                format: [
                    widthMM,
                    heightMM
                ],

                compress: true
            });

        } else {

            // ============================================
            // الصفحات التالية بنفس مقاس التصميم
            // ============================================

            pdf.addPage(
                [widthMM, heightMM],
                widthMM > heightMM
                    ? "landscape"
                    : "portrait"
            );
        }

        // ================================================
        // إضافة الصورة بدون تغيير التصميم
        // ================================================

        pdf.addImage(
            canvas.toDataURL("image/png", 1.0),
            "PNG",
            0,
            0,
            widthMM,
            heightMM,
            undefined,
            "FAST"
        );
    }

    if (!pdf) {
        throw new Error("فشل إنشاء ملف PDF");
    }

    return pdf;
};

const createInvoicePDF = async () => {

    const pages = document.querySelectorAll(".pageinv");

    if (!pages.length) {
        throw new Error("لم يتم العثور على صفحات الفاتورة");
    }

    // ==========================================
    // مقاس A4 ثابت
    // ==========================================
    const PDF_WIDTH = 210;
    const PDF_HEIGHT = 297;

    // ==========================================
    // انتظار الخطوط
    // ==========================================
    await document.fonts.ready;

    try {
        await Promise.all([
            document.fonts.load(
                'normal 10px "Noto Sans Arabic"'
            ),
            document.fonts.load(
                'bold 10px "Noto Sans Arabic"'
            )
        ]);
    } catch (error) {
        console.warn("Font loading warning:", error);
    }

    // إعطاء المتصفح فرصة لإكمال الرسم
    await new Promise(resolve =>
        requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
        })
    );

    let pdf = null;

    for (let i = 0; i < pages.length; i++) {

        const page = pages[i];

        const rect = page.getBoundingClientRect();

        const pageWidth = Math.round(rect.width);
        const pageHeight = Math.round(rect.height);

        // ==========================================
        // تصوير الصفحة
        // ==========================================
        const canvas = await html2canvas(page, {

            // دقة عالية وثابتة
            scale: 3,

            backgroundColor: "#ffffff",

            useCORS: true,

            allowTaint: false,

            logging: false,

            width: pageWidth,

            height: pageHeight,

            x: 0,

            y: 0,

            scrollX: -window.scrollX,

            scrollY: -window.scrollY,

            windowWidth:
                document.documentElement.scrollWidth,

            windowHeight:
                document.documentElement.scrollHeight,

            imageTimeout: 15000
        });

        // ==========================================
        // إنشاء PDF A4
        // ==========================================
        if (!pdf) {

            pdf = new jsPDF({

                orientation: "portrait",

                unit: "mm",

                format: [PDF_WIDTH, PDF_HEIGHT],

                compress: true
            });

        } else {

            pdf.addPage(
                [PDF_WIDTH, PDF_HEIGHT],
                "portrait"
            );
        }

        // ==========================================
        // الصورة داخل A4
        // ==========================================
        const img = canvas.toDataURL(
            "image/jpeg",
            0.75
        );

        pdf.addImage(
            img,
            "JPEG",
            0,
            0,
            PDF_WIDTH,
            PDF_HEIGHT,
            undefined,
            "FAST"
        );

        // ==========================================
        // تحرير الذاكرة
        // ==========================================
        canvas.width = 1;
        canvas.height = 1;

        await new Promise(resolve =>
            requestAnimationFrame(resolve)
        );
    }

    return pdf;
};


const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
const createInvoicePDFIOS = async () => {

    const pages = document.querySelectorAll(".pageinv");

    if (!pages.length) {
        throw new Error("لم يتم العثور على صفحات الفاتورة");
    }

    // =====================================================
    // A4
    // =====================================================

    const PDF_WIDTH = 210;
    const PDF_HEIGHT = 297;


    // =====================================================
    // iPhone / iPad
    // =====================================================

    const isIOS =
        /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        (
            navigator.platform === "MacIntel" &&
            navigator.maxTouchPoints > 1
        );


    // =====================================================
    // العناصر التي تحتاج معالجة خاصة
    // =====================================================

    const DESCRIPTION_SELECTOR =
        "#arb2qg, .invoice-footerar, .pdf-description";

    const ITEM_NAME_SELECTOR =
        ".invoice-rows";


    // =====================================================
    // انتظار الخطوط
    // =====================================================

    await document.fonts.ready;

    try {

        await Promise.all([
            document.fonts.load(
                'normal 10px "Noto Sans Arabic"'
            ),

            document.fonts.load(
                'bold 10px "Noto Sans Arabic"'
            ),

            document.fonts.load(
                'normal 10px "Amiri-Regular"'
            ),

            document.fonts.load(
                'bold 10px "Amiri-Regular"'
            )
        ]);

    } catch (error) {

        console.warn(
            "Font loading warning:",
            error
        );
    }


    // =====================================================
    // إعطاء المتصفح فرصة لإكمال الرسم
    // =====================================================

    await new Promise(resolve =>
        requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
        })
    );


    // =====================================================
    // إذا كان الجهاز ليس iPhone/iPad
    // لا نحتاج معالجة النص الخاصة
    // =====================================================

    if (!isIOS) {

        let pdf = null;

        for (let i = 0; i < pages.length; i++) {

            const page = pages[i];

            const rect =
                page.getBoundingClientRect();

            const pageWidth =
                Math.round(rect.width);

            const pageHeight =
                Math.round(rect.height);


            const canvas =
                await html2canvas(page, {

                    scale: 4,

                    backgroundColor: "#ffffff",

                    useCORS: true,

                    allowTaint: false,

                    logging: false,

                    width: pageWidth,

                    height: pageHeight,

                    x: 0,

                    y: 0,

                    scrollX: -window.scrollX,

                    scrollY: -window.scrollY,

                    windowWidth:
                        document.documentElement.scrollWidth,

                    windowHeight:
                        document.documentElement.scrollHeight,

                    imageTimeout: 15000
                });


            if (!pdf) {

                pdf = new jsPDF({
                    orientation: "portrait",
                    unit: "mm",
                    format: [
                        PDF_WIDTH,
                        PDF_HEIGHT
                    ],
                    compress: true
                });

            } else {

                pdf.addPage(
                    [
                        PDF_WIDTH,
                        PDF_HEIGHT
                    ],
                    "portrait"
                );
            }


            const img =
                canvas.toDataURL(
                    "image/jpeg",
                    0.90
                );


            pdf.addImage(
                img,
                "JPEG",
                0,
                0,
                PDF_WIDTH,
                PDF_HEIGHT,
                undefined,
                "FAST"
            );


            canvas.width = 1;
            canvas.height = 1;

            await new Promise(resolve =>
                requestAnimationFrame(resolve)
            );
        }

        return pdf;
    }


    // =====================================================
    // iOS فقط
    // =====================================================

    const elementsToRestore = [];


    // =====================================================
    // دالة رسم النص العربي / الإنجليزي / الأرقام
    // =====================================================

    const replaceElementWithImage = async (
        element
    ) => {

        if (!element) {
            return;
        }


        const text =
            element.textContent || "";


        if (!text.trim()) {
            return;
        }


        const rect =
            element.getBoundingClientRect();


        if (
            rect.width <= 0 ||
            rect.height <= 0
        ) {
            return;
        }


        const style =
            window.getComputedStyle(element);


        // -------------------------------------------------
        // حفظ العنصر
        // -------------------------------------------------

        elementsToRestore.push({
            element: element,
            html: element.innerHTML,
            style: element.getAttribute("style")
        });


        // -------------------------------------------------
        // Retina
        // -------------------------------------------------

        const ratio = 3;


        const width =
            Math.ceil(rect.width);


        const height =
            Math.ceil(rect.height);


        const canvas =
            document.createElement("canvas");


        canvas.width =
            Math.ceil(width * ratio);


        canvas.height =
            Math.ceil(height * ratio);


        const ctx =
            canvas.getContext("2d");


        if (!ctx) {
            return;
        }


        ctx.setTransform(
            ratio,
            0,
            0,
            ratio,
            0,
            0
        );


        // -------------------------------------------------
        // اتجاه النص
        // -------------------------------------------------

        const direction =
            style.direction === "ltr"
                ? "ltr"
                : "rtl";


        ctx.direction =
            direction;


        ctx.textAlign =
            direction === "rtl"
                ? "right"
                : "left";


        ctx.textBaseline =
            "top";


        // -------------------------------------------------
        // الخط
        // -------------------------------------------------

        const fontSize =
            parseFloat(style.fontSize) || 14;


        const fontWeight =
            style.fontWeight || "normal";


        const fontStyle =
            style.fontStyle || "normal";


        const fontFamily =
            style.fontFamily ||
            '"Noto Sans Arabic", Arial, sans-serif';


        ctx.font =
            `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;


        ctx.fillStyle =
            style.color || "#000000";


        // -------------------------------------------------
        // line height
        // -------------------------------------------------

        let lineHeight =
            parseFloat(style.lineHeight);


        if (
            !lineHeight ||
            Number.isNaN(lineHeight)
        ) {

            lineHeight =
                fontSize * 1.35;
        }


        // -------------------------------------------------
        // Padding
        // -------------------------------------------------

        const paddingLeft =
            parseFloat(style.paddingLeft) || 0;


        const paddingRight =
            parseFloat(style.paddingRight) || 0;


        const paddingTop =
            parseFloat(style.paddingTop) || 0;


        const availableWidth =
            width -
            paddingLeft -
            paddingRight;


        // =================================================
        // تقسيم النص
        // =================================================

        const paragraphs =
            text
                .replace(/\r\n/g, "\n")
                .replace(/\r/g, "\n")
                .split("\n");


        const lines = [];


        for (
            const paragraph
            of paragraphs
        ) {

            if (!paragraph.trim()) {

                lines.push("");

                continue;
            }


            const words =
                paragraph.trim().split(/\s+/);


            let currentLine = "";


            for (
                const word
                of words
            ) {

                const testLine =
                    currentLine
                        ? currentLine + " " + word
                        : word;


                const testWidth =
                    ctx.measureText(
                        testLine
                    ).width;


                if (
                    testWidth <=
                    availableWidth
                ) {

                    currentLine =
                        testLine;

                } else {

                    if (currentLine) {

                        lines.push(
                            currentLine
                        );
                    }


                    // -------------------------------------
                    // إذا كانت الكلمة نفسها أطول من العرض
                    // -------------------------------------

                    if (
                        ctx.measureText(word).width >
                        availableWidth
                    ) {

                        let part = "";


                        for (
                            const char
                            of word
                        ) {

                            const testPart =
                                part + char;


                            if (
                                ctx.measureText(
                                    testPart
                                ).width <=
                                availableWidth
                            ) {

                                part =
                                    testPart;

                            } else {

                                if (part) {

                                    lines.push(
                                        part
                                    );
                                }


                                part = char;
                            }
                        }


                        currentLine = part;

                    } else {

                        currentLine = word;
                    }
                }
            }


            if (currentLine) {

                lines.push(
                    currentLine
                );
            }
        }


        // =================================================
        // X
        // =================================================

        const x =
            direction === "rtl"
                ? width - paddingRight
                : paddingLeft;


        // =================================================
        // رسم النص
        // =================================================

        lines.forEach(
            (line, index) => {

                const y =
                    paddingTop +
                    index * lineHeight;


                ctx.fillText(
                    line,
                    x,
                    y
                );
            }
        );


        // =================================================
        // تحويل Canvas إلى صورة
        // =================================================

        const image =
            document.createElement("img");


        image.src =
            canvas.toDataURL(
                "image/png"
            );


        image.style.display =
            "block";


        image.style.width =
            `${width}px`;


        image.style.height =
            `${height}px`;


        image.style.maxWidth =
            "none";


        image.style.margin =
            "0";


        image.style.padding =
            "0";


        // =================================================
        // استبدال النص بالصورة
        // =================================================

        element.innerHTML = "";

        element.appendChild(image);


        await new Promise(resolve => {

            if (image.complete) {

                resolve();

            } else {

                image.onload = resolve;
                image.onerror = resolve;
            }

        });


        // تحرير Canvas
        canvas.width = 1;
        canvas.height = 1;
    };


    try {

        // =================================================
        // معالجة الملاحظة
        // =================================================

        for (const page of pages) {

            const descriptions =
                page.querySelectorAll(
                    DESCRIPTION_SELECTOR
                );


            for (
                const element
                of descriptions
            ) {

                await replaceElementWithImage(
                    element
                );
            }
        }


        // =================================================
        // معالجة أسماء الأصناف
        // =================================================

        for (const page of pages) {

            const itemNames =
                page.querySelectorAll(
                    ITEM_NAME_SELECTOR
                );


            for (
                const element
                of itemNames
            ) {

                await replaceElementWithImage(
                    element
                );
            }
        }


        // =================================================
        // انتظار Safari
        // =================================================

        await new Promise(resolve =>
            requestAnimationFrame(() => {
                requestAnimationFrame(resolve);
            })
        );


        // =================================================
        // إنشاء PDF
        // =================================================

        let pdf = null;


        for (
            let i = 0;
            i < pages.length;
            i++
        ) {

            const page = pages[i];


            const rect =
                page.getBoundingClientRect();


            const pageWidth =
                Math.round(rect.width);


            const pageHeight =
                Math.round(rect.height);


            // =============================================
            // تصوير الصفحة
            // =============================================

            const canvas =
                await html2canvas(
                    page,
                    {

                        scale: 3,

                        backgroundColor:
                            "#ffffff",

                        useCORS:
                            true,

                        allowTaint:
                            false,

                        logging:
                            false,

                        width:
                            pageWidth,

                        height:
                            pageHeight,

                        x:
                            0,

                        y:
                            0,

                        scrollX:
                            -window.scrollX,

                        scrollY:
                            -window.scrollY,

                        windowWidth:
                            document.documentElement
                                .scrollWidth,

                        windowHeight:
                            document.documentElement
                                .scrollHeight,

                        imageTimeout:
                            15000
                    }
                );


            // =============================================
            // PDF
            // =============================================

            if (!pdf) {

                pdf =
                    new jsPDF({

                        orientation:
                            "portrait",

                        unit:
                            "mm",

                        format:
                            [
                                PDF_WIDTH,
                                PDF_HEIGHT
                            ],

                        compress:
                            true
                    });

            } else {

                pdf.addPage(
                    [
                        PDF_WIDTH,
                        PDF_HEIGHT
                    ],
                    "portrait"
                );
            }


            // =============================================
            // JPEG
            // =============================================

            const img =
                canvas.toDataURL(
                    "image/jpeg",
                    0.88
                );


            pdf.addImage(
                img,
                "JPEG",
                0,
                0,
                PDF_WIDTH,
                PDF_HEIGHT,
                undefined,
                "FAST"
            );


            // =============================================
            // تحرير الذاكرة
            // =============================================

            canvas.width = 1;
            canvas.height = 1;


            await new Promise(resolve =>
                requestAnimationFrame(resolve)
            );
        }


        return pdf;


    } finally {

        // =================================================
        // إعادة العناصر إلى حالتها الأصلية
        // =================================================

        elementsToRestore.forEach(
            item => {

                item.element.innerHTML =
                    item.html;


                if (
                    item.style === null
                ) {

                    item.element.removeAttribute(
                        "style"
                    );

                } else {

                    item.element.setAttribute(
                        "style",
                        item.style
                    );
                }
            }
        );
    }
};
export const downloadInvoicePdf = async (fileName) => {

    try {
        const pdf = isIOS ? await createInvoicePDFIOS() : await createInvoicePDF();
        pdf.save(fileName);
    } catch (error) {

        console.error("PDF Error:", error);

    }
};

export const shareInvoicePdf = async (fileName) => {
    const pdf = isIOS ? await createInvoicePDFIOS() : await createInvoicePDF();
    if (!pdf) return;
    let mFile = null;
    const blob = pdf.output('blob');
    mFile = new File(
        [blob],
        isIOS?fileName+".pdf":fileName,
        { type: blob.type }
    );
    if (navigator.share && navigator.canShare?.({ files: [mFile] })) {
        await navigator.share({
            title: "",
            text: "",
            files: [mFile]
        });

    } else {
        alert("cant share files");
    }
};


export const shareInvoiceToWhatsApp = async (
    customerMobile,
    customerName,
    invoiceNo,
    invoiceDate,
    totalAmount,
    taxAmount
) => {

    try {

        if (!customerMobile) {
            alert("لا يوجد رقم جوال للعميل");

            return;
        }
        const pdfBlob =  await createInvoicePDF();

        // ==============================
        // تنظيف رقم الجوال
        // ==============================

        let phone = String(customerMobile)
            .replace(/\s/g, "")
            .replace(/-/g, "")
            .replace(/\(/g, "")
            .replace(/\)/g, "");

        // 05xxxxxxxx
        if (phone.startsWith("05")) {
            phone = "966" + phone.substring(1);
        }

        // +9665xxxxxxxx
        if (phone.startsWith("+966")) {
            phone = phone.substring(1);
        }

        // 9665xxxxxxxx
        if (!phone.startsWith("966")) {
            phone = "966" + phone;
        }


        // ==============================
        // تنسيق المبالغ
        // ==============================

        const formatMoney = (value) => {

            const number = Number(value || 0);

            return number.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        };


        // ==============================
        // رسالة الواتساب
        // ==============================

        const message =
`السلام عليكم ورحمة الله وبركاته 👋

شكرًا لزيارتكم وثقتكم بنا 🌹

عزيزي العميل: ${customerName || ""}

🧾 رقم الفاتورة: ${invoiceNo}
📅 التاريخ: ${invoiceDate}

💰 الإجمالي شامل الضريبة: ${formatMoney(totalAmount)} ريال
🧾 ضريبة القيمة المضافة: ${formatMoney(taxAmount)} ريال

نتمنى لكم تجربة سعيدة، ونسعد بخدمتكم دائمًا ❤️

شكرًا لاختياركم لنا 🌷`;


        // ==============================
        // إنشاء ملف PDF
        // ==============================

        const file = new File(
            [pdfBlob],
            `فاتورة رقم ${invoiceNo}.pdf`,
            {
                type: "application/pdf"
            }
        );


        // ==============================
        // iPhone / Android
        // مشاركة PDF + الرسالة
        // ==============================

        if (
            navigator.share &&
            navigator.canShare &&
            navigator.canShare({
                files: [file]
            })
        ) {

            await navigator.share({
                title: `فاتورة رقم ${invoiceNo}`,
                text: message,
                files: [file]
            });

            return;
        }


        // ==============================
        // في حالة عدم دعم مشاركة الملفات
        // فتح واتساب على رقم العميل
        // ==============================

        const whatsappUrl =
            `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

        window.location.href = whatsappUrl;

    } catch (error) {

        // المستخدم أغلق شاشة المشاركة
        if (error?.name === "AbortError") {
            return;
        }

        console.error("WhatsApp Share Error:", error);

        alert("تعذر مشاركة الفاتورة عبر واتساب");
    }
};





